import { Register } from "@tanstack/react-router";
import { TanStackRouterDevtoolsInProd } from "@tanstack/react-router-devtools";
import { useEffect, useState } from "react";

const GlobalForQueryDevTools = window as unknown as {
  toggleRouterDevTools: () => void;
};

export function RouterDevTools({ router }: { router: Register["router"] }) {
  const [showDevtools, setShowDevtools] = useState(false);
  useEffect(() => {
    GlobalForQueryDevTools.toggleRouterDevTools = () => {
      setShowDevtools((prev) => !prev);
    };
  }, []);

  if (!showDevtools) return <></>;

  return <TanStackRouterDevtoolsInProd router={router} />;
}
